import service from "./service"

const workStatusOptions = async () => {
    return service()
}

export default workStatusOptions
